import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';
import { parseCategories } from '../../../utils/parseCategories';

import styles from './BannerLeads.module.scss';

const BannerLeads = (props) => {
  const { slug, utmMedium, categories } = props;
  const router = useRouter();
  const categorySlug = parseCategories.getSlug(categories);

  const data = {
    title: 'Promo Asuransi Terbaik, Hemat 30%! ',
    subtitle: 'Bandingkan ratusan pilihan sesuai kebutuhanmu.',
    banner_link: `https://lifepal.co.id/promo/kesehatan/?utm_campaign=MEDIA_HEA_USPTagline&utm_source=media&utm_medium=${utmMedium}_text&utm_content=${slug}`,
    buttons: [
      {
        id: 'health',
        link: `https://lifepal.co.id/promo/kesehatan/?utm_campaign=MEDIA_HEA_USPTagline&utm_source=media&utm_medium=${utmMedium}&utm_content=${slug}`,
        text: 'Asuransi Kesehatan',
      },
      {
        id: 'auto',
        link: `https://lifepal.co.id/promo/mobil/?utm_campaign=MEDIA_AUT_USPTagline&utm_source=media&utm_medium=${utmMedium}&utm_content=${slug}`,
        text: 'Asuransi Mobil',
      },
      {
        id: 'life',
        link: `https://lifepal.co.id/promo/jiwa/?utm_campaign=MEDIA_LIF_USPTagline&utm_source=media&utm_medium=${utmMedium}&utm_content=${slug}`,
        text: 'Asuransi Jiwa',
      },
    ],
  };

  return (
    <div className={styles['widget-banner-leads']}>
      <a
        href={data.banner_link}
        title={data.title}
        className={classnames(
          GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
          `${GTM_CLASS_PREFIX}${categorySlug}`,
        )}
      >
        <div className={styles['widget-banner-leads__head']}>
          <div className={styles['widget__banner--links']}>
            <Link href={data.banner_link} prefetch={false}>
              <a
                className={classnames(
                  styles['widget-banner-leads__head-title'],
                  GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
                  `${GTM_CLASS_PREFIX}${categorySlug}`,
                )}
                title={data.title}
              >
                {data.title}
              </a>
            </Link>
            <Link href={data.banner_link} prefetch={false}>
              <a
                className={classnames(
                  styles['widget-banner-leads__head-subtitle'],
                  GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
                  `${GTM_CLASS_PREFIX}${categorySlug}`,
                )}
                title={data.subtitle}
              >
                {data.subtitle}
              </a>
            </Link>
          </div>
          <div className={styles['widget__banner--image']}>
            <img
              src={`${router.basePath}/static/images/banner-leads-people.png`}
              width="140"
              height="120"
              loading="lazy"
              alt={data.title}
            />
          </div>
        </div>
        <div
          className={classnames(
            styles['widget-banner-leads__footer'],
            styles['widget-banner-leads__footer--horizontal'],
          )}
        >
          {data.buttons.map((button) => (
            <Link key={button.id} href={button.link} prefetch={false}>
              <a
                title={button.text}
                className={classnames(
                  GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
                  `${GTM_CLASS_PREFIX}${categorySlug}`,
                )}
              >
                {button.text}
              </a>
            </Link>
          ))}
        </div>
      </a>
    </div>
  );
};

export default BannerLeads;
